import React from 'react';
import Header from '../directives/header';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
} from 'react-bootstrap';
import '../css/home2.css';
import Footer from '../directives/footer';
import ConnectWallent from '../../Common/ConnectWallent';
import config from '../../config/config';
import { useAccount } from 'wagmi';
import { Toaster, toast } from 'react-hot-toast';

const Forinvestor = () => {

  const { isConnected } = useAccount();
  const handleRedirectPage = () => {
    if (isConnected) {
      window.location.href = `${config.baseUrl}project`;
    } else {
      toast.error('Please connect your wallet first')
    }
  };

  return (
    <>
      <Toaster />
      <div className="home2">
        <Header />
        <section className="herobanner position-relative">
          <div className="bgleft position-absolute top-0 bottom-0 start-0">
            <img src="assets/images/shape/bgleftshadow.svg" />
          </div>
          {/* <div className="bgright position-absolute top-0 bottom-0 end-0">
            <img src="assets/images/shape/blueshadow.svg" />
          </div> */}
          <Container className="pt-5 mt-4">
            <Row className="justify-content-center mb-5">
              <Col lg={10} className="text-center px-lg-5">
                <h1 className="text-white fw-bold">FOR INVESTORS</h1>
                <p>
                  we believe that Investors are the backbone of innovation. By
                  providing capital to promising blockchain projects, you help
                  drive technological advancements while earning rewards,
                  governance power, and long-term growth opportunities.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={12} className="">
                <Row>
                  <Col lg={4} md={6} className="mb-4">
                    <Card className=" bg-transparent border-0">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/support.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <div className="text-center mb-4">
                              <h4 className="text-white">
                                Browse Verified Projects
                              </h4>
                            </div>
                            <ul>
                              <li className="mb-3">
                                Access a list of vetted blockchain projects
                                looking for funding.
                              </li>
                              <li>
                                Review project details, team backgrounds, and
                                growth potential.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} className="mb-4">
                    <Card className="bg-transparent border-0">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/support.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <div className="text-center mb-4">
                              <h4 className="text-white">
                                Check Investment Options{' '}
                              </h4>
                            </div>
                            <ul>
                              <li className="mb-3">
                                Choose between staking UTX for passive income or
                                direct project funding.
                              </li>
                              <li>
                                Analyze expected returns, risk factors, and
                                potential rewards.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} className="mb-4">
                    <Card className=" bg-transparent border-0">
                      <Card.Body className="p-0">
                        <div>
                          <div className="blueBox mb-4">
                            <img src="assets/images/icon/support.svg" />
                          </div>
                          <div className="pt-0 z-1">
                            <div className="text-center mb-4">
                              <h4 className="text-white">
                                Make an Informed Decision
                              </h4>
                            </div>
                            <ul>
                              <li className="mb-3">
                                Utilize platform-provided insights like project
                                ratings, audits, and roadmaps.
                              </li>
                              <li>
                                Join the UTX community discussions to get
                                real-time feedback.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="secure py-0">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-4 text-center">
                <div className="heading my-4 ">
                  <h1 className="text-white fw-normal">
                    Secure & Transparent Investment Process
                  </h1>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col lg={6} className="mb-5">
                <div>
                  <ul className="mb-0">
                    <li className="mb-5">
                      <b className="text-white">Smart Contracts :</b> Automated
                      and tamper-proof execution of investments.
                    </li>

                    <li className="mb-5">
                      <b className="text-white"> Real-Time Tracking :</b>{' '}
                      Monitor portfolio performance directly on the platform.
                    </li>

                    <li className="">
                      <b className="text-white">Regular Project Updates :</b>{' '}
                      Stay informed with milestone reports and progress
                      tracking.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={6} className="mb-5">
                <div className="mb-5">
                  <img
                    src="assets/images/moneysecure.png"
                    width={`100%`}
                    height={`330px`}
                    className="object-fit-contain"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="getintouch pt-0">
          <ConnectWallent></ConnectWallent>

          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <Button variant="primary" className="text-black" onClick={handleRedirectPage}>
                Invest Now
              </Button>
            </Col>
          </Row>

        </section>
        <Footer />
      </div>
    </>
  );
};
export default Forinvestor;
